import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SET_CMS_DATA
    `,
    {
        prefix: "luxuryCars/"
    }
);
